import { HorizontalDivider } from "components";
import type { HorizontalDividerProps } from "components/HorizontalDivider/HorizontalDivider.d";
import type { ReactStoryblokComponent } from "types/storyblok";

export const HorizontalDividerAdapter = ({
  blok: { myDesktop, myMobile, myTablet, hideOnDesktop, hideOnMobile, hideOnTablet, pxDesktop, pxMobile, pxTablet },
  sbEditable,
}: ReactStoryblokComponent<HorizontalDividerProps>) => (
  <HorizontalDivider
    myDesktop={myDesktop}
    myTablet={myTablet}
    myMobile={myMobile}
    sbEditable={sbEditable}
    hideOnDesktop={hideOnDesktop}
    hideOnTablet={hideOnTablet}
    hideOnMobile={hideOnMobile}
    pxDesktop={pxDesktop}
    pxTablet={pxTablet}
    pxMobile={pxMobile}
  />
);
